import { useEffect, useState } from "react"
import useScrollIntoView from "./useScrollIntoView"

export default function useReportScrolledIntoView(elRef, category, action, data) {
  const inView = useScrollIntoView(elRef)
  const [reportedInView, setReportedInView] = useState(false)

  useEffect(() => {
    if (!inView || reportedInView) return

    setReportedInView(true)
  }, [inView, reportedInView])

  return reportedInView
}
